import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation, useParams } from 'react-router-dom';

/**
 * Vision Board used to be a company section of its own at `/:slug/vision-board`.
 * It lives inside Self Development now, so those URLs redirect rather than 404
 * — bookmarks, links pasted into Slack and the old dashboard card all still
 * land somewhere sensible.
 *
 * `search` is carried across because the user-detail page identifies its
 * subject with `?userId=`, and dropping it would bounce whoever followed the
 * link back to an empty list.
 */
const VisionBoardRedirect = ({ to = '' }) => {
  const { slug } = useParams();
  const { search } = useLocation();

  return <Navigate to={`/${slug}/self-development/vision-board${to}${search}`} replace />;
};

VisionBoardRedirect.propTypes = {
  /** Path suffix under the new Vision Board tab — '', '/users' or '/user'. */
  to: PropTypes.string
};

export default VisionBoardRedirect;

/** Route-level bindings, so adminRoutes.js stays a list of components. */
export const VisionBoardDashboardRedirect = () => <VisionBoardRedirect to="" />;
export const VisionBoardUsersRedirect = () => <VisionBoardRedirect to="/users" />;
export const VisionBoardUserRedirect = () => <VisionBoardRedirect to="/user" />;
